import React, { ReactNode, VFC } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';

const useStyles = makeStyles((theme) => ({
  timeline: {
    padding: 0,
    margin: 0,
  },
  timelineGradient: {
    height: '80px',
    overflow: 'hidden',
    position: 'relative',

    '&::before': {
      content: "''",
      width: '100%',
      height: '100%',
      display: 'block',
      background:
        'linear-gradient(rgb(253, 249, 234, 0) 50%, rgb(253, 249, 234, 1))',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
    },
  },
}));

interface Props {
  expanded: boolean;
  children: ReactNode;
}
const AccordionTimeline: VFC<Props> = ({ expanded, children }: Props) => {
  const classes = useStyles();
  return (
    <Timeline
      align="left"
      className={clsx(classes.timeline, !expanded && classes.timelineGradient)}
    >
      {children}
    </Timeline>
  );
};

export default AccordionTimeline;
